/**
 * @name: scene setting api
 * @description:
 * @author: qq2575896094
 * @time: 2024/11/12
 */

const prefix = '/onlinecs/scene'

// 新增会话场景菜单
export const addSessionSceneInfo = `${prefix}/addSessionSceneInfo`

// 获取所有会话场景菜单
export const getAllSessionSceneList = `${prefix}/getAllSessionSceneList`

// 获取单个会话场景菜单
export const getSessionSceneInfo = `${prefix}/getSessionSceneInfo`

// 修改单个会话场景菜单
export const modifySessionScene = `${prefix}/modifySessionScene`

// 删除单个会话场景菜单
export const removeSessionScene = `${prefix}/removeSessionScene`
